import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { Image, Touchable, styled } from 'modules/styled';
import { isNative } from 'styles';
import Tooltip from 'modules/tooltip/tooltip.component';
import { VOTE_BUTTON_SIZE } from 'styles/layout';

const BUTTON_IMAGES = {
  UPVOTE: {
    white: require('public/img/vote_buttons/upvote-white.png'),
    default: require('public/img/vote_buttons/upvote-grey-outline.png'),
    active: require('public/img/vote_buttons/upvote-blue.png'),
    hover: require('public/img/vote_buttons/upvote-blue-outline.png'),
  },
  DOWNVOTE: {
    white: require('public/img/vote_buttons/downvote-white.png'),
    default: require('public/img/vote_buttons/downvote-grey-outline.png'),
    active: require('public/img/vote_buttons/downvote-red.png'),
    hover: require('public/img/vote_buttons/downvote-red-outline.png'),
  },
};

const transition = !isNative
  ? {
      transitionProperty: 'all',
      transitionDuration: '0.2s',
      transitionTimingFunction: 'ease',
    }
  : {};

const ButtonImage = styled(Image)((p) => ({
  ...transition,
  transform: p.hover && !p.active && !p.disabled && !isNative ? 'scale(1.1)' : [],
}));

PostButton.propTypes = {
  color: PropTypes.string,
  alt: PropTypes.string,
  isActive: PropTypes.bool,
  imageSet: PropTypes.oneOf(['DOWNVOTE', 'UPVOTE']),
  onPress: PropTypes.func,
  tooltipData: PropTypes.object,
};

function PostButton({ alt, isActive, imageSet, onPress, color, tooltipData }) {
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(false);

  const images = BUTTON_IMAGES[imageSet];
  const defaultState = images[color] || images.default;
  const source = (isActive && images.active) || (hover && images.hover) || defaultState;
  return (
    <Tooltip data={tooltipData} name="voteDesk">
      <Touchable onPress={onPress} hitSlop={{ top: 6, left: 6, right: 6, bottom: 6 }}>
        <ButtonImage
          sx={{
            width: VOTE_BUTTON_SIZE,
            height: VOTE_BUTTON_SIZE,
          }}
          alt={alt}
          resizeMode="contain"
          source={source}
          hover={hover}
          active={active}
          onMouseDown={() => setActive(1)}
          onMouseUp={() => setActive(0)}
          onMouseEnter={() => setHover(1)}
          onMouseLeave={() => {
            setHover(0);
            setActive(0);
          }}
        />
      </Touchable>
    </Tooltip>
  );
}

export default memo(PostButton);
